import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Grid } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/grid';
import './Gallery.css';
import gellaryServices from '../../services/gellaryServices';
import ImageWithFallback from '../ImageWithFallback';

const GallerySection = styled(Box)({
  padding: '40px 0',
  backgroundColor: '#fff'
});

const SliderContainer = styled(Box)({
  '& .swiper': {
    width: '100%',
    padding: '20px 0'
  },
  '& .swiper-button-next, & .swiper-button-prev': {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    color: '#fff',
    '&::after': {
      fontSize: '20px'
    }
  },
  '& .swiper-pagination': {
    bottom: '-5px'
  }
});

const ImageContainer = styled(Box)({
  position: 'relative',
  paddingTop: '75%', // 4:3 Aspect ratio
  overflow: 'hidden',
  margin: '10px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  '&:hover img': {
    transform: 'scale(1.05)'
  }
});

const GalleryImage = styled('img')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  transition: 'transform 0.3s ease'
});

const SectionTitle = styled(Typography)({
  textAlign: 'center',
  fontSize: '32px',
  fontWeight: '500',
  marginBottom: '30px',
  color: '#333',
  position: 'relative',
  '&:after': {
    content: '""',
    position: 'absolute',
    bottom: -10,
    left: '50%',
    transform: 'translateX(-50%)',
    width: '60px',
    height: '3px',
    backgroundColor: '#008751' // Using your green color
  }
});

// Update sample data to use your actual images


const Gallery = () => {
  const [data, setData] = useState([])


  const getData = () => {
    gellaryServices
      .get()
      .then((res) => {
        console.log("---res---", res);
        setData(res?.data?.data)
      })
      .catch(() => { });
  };

  useEffect(() => {
    getData();
  }, [])

  const imagePaths = data.flatMap(item => item.images.map(img => img.path));

  return (
    <GallerySection>
      <Typography
        variant="h4"
        fontWeight="bold"
        textAlign="center"
        gutterBottom
        color="rgba(26,128,200)"

      >
        Photo Gallery
      </Typography>
      <SliderContainer>
        <Swiper
          modules={[Navigation, Pagination, Grid]}
          spaceBetween={20}
          slidesPerView={4}
          navigation
          pagination={{ clickable: true }}
          grid={{
            rows: 2,
            fill: 'row'
          }}
          breakpoints={{
            320: {
              slidesPerView: 1,
              grid: { rows: 1 }
            },
            640: {
              slidesPerView: 2,
              grid: { rows: 1 }
            },
            1024: {
              slidesPerView: 3,
              grid: { rows: 1 }
            }
          }}
        >
          {data?.flatMap(item => item?.images?.map(img => img.path))?.map((image, idx) => (
            <SwiperSlide key={image + String(idx)}>
              <ImageContainer>
                <ImageWithFallback
                  path={image}
                  alt=""
                  style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover", transition: "transform 0.3s ease" }}
                />
              </ImageContainer>
            </SwiperSlide>
          ))}
        </Swiper>
      </SliderContainer>
    </GallerySection>
  );
};

export default Gallery; 